module.exports = __webpack_public_path__ + "static/html-element_5-9d9be0680fb4530e073a2c294cebe0bf.jpg";